// Travel Max Sale and BBD Time Configuration
export const SALE_CONFIG = {
  PRE_START_TIME: '2026-10-08T00:00:00',
  START_TIME: '2026-10-08T00:00:00',
  END_TIME: '2026-10-18T23:59:59'
} as const;

export const BLACK_FRIDAY_SALE_CONFIG = {
  START_TIME: '2025-11-25T00:00:00',
  END_TIME: '2025-12-03T23:59:59'
} as const;